interface GearUpgradeIconProps {
  className?: string
  size?: number
}

/**
 * Engrenagem com seta para cima ao centro — metáfora de "upgrade/melhoria
 * do sistema". Single path com fill-rule="evenodd": a seta cria um cutout
 * dentro da engrenagem, deixando o gradiente do FAB visível através dela.
 *
 * Path da engrenagem baseado no Material Design `settings` icon
 * (24×24 viewBox, 8 dentes). Seta desenhada como caminho inverso pra
 * cutout via even-odd winding rule.
 */
export function GearUpgradeIcon({ className, size = 24 }: GearUpgradeIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 7.4L8 11.4h2.5v6.2h3v-6.2H16L12 7.4z"
      />
    </svg>
  )
}
